
  /* UFE inc-VAT price rewrite.

     UFE Cross Sell & Upsell Bundle injects its widget into
     `.product-details[data-product-details]` (the buy-box wrapper). It
     renders prices as `<span class="money">£X.XX</span>` reading the
     raw ex-VAT figure from Shopify, with no awareness of the theme's
     × 1.2 inc-VAT display convention. This observer watches the UFE
     container for new/changed price spans, multiplies the displayed
     value by 1.2 for the inc-VAT headline, and adds a small "(Exc VAT)"
     line alongside — matches the .bb-price-now / .bb-price-ex layout
     used by the main buy-box price above.

     Why a MutationObserver rather than running once on load: UFE renders
     asynchronously (after Shopify's app embed script bootstraps), and
     re-renders on variant changes / cart updates. The observer catches
     all of those without us needing to know UFE's lifecycle hooks.

     Idempotent: each processed span gets our `.ufe-vat-inc` child, so
     subsequent observer fires skip already-processed spans. If UFE
     re-renders a price (variant change), it overwrites the span's
     innerHTML — our marker class disappears — and the next observer
     pass processes it again with the new value. */
  (function () {
    function init() {
      /* Container to observe + scope price queries to. Prefer the
         buy-box wrapper (where UFE is configured to inject), fall
         back to <body> if the wrapper isn't present on this template.
         The price selector `.upsellPrice > span` is specific enough
         that observing the whole body doesn't cause false matches. */
      var container = document.querySelector('.product-details[data-product-details]')
                   || document.body;
      if (!container) return;

      /* Cloak class — pairs with the CSS rule that hides unprocessed
         `.upsellPrice > span` elements. Set BEFORE the observer wires
         up so any UFE price that appears in the first frame is hidden,
         not flashed. Removed after 3 seconds as a backstop — if for
         any reason the observer never processes a particular price
         element (e.g. UFE rendered into a sub-iframe, observer didn't
         fire), we'd rather show the ex-VAT price than leave the slot
         blank forever. Per-element reveal (via the `is-vat-ready`
         class) still happens immediately as each price is processed. */
      document.documentElement.classList.add('has-ufe-vat-rewriter');
      setTimeout(function () {
        document.documentElement.classList.remove('has-ufe-vat-rewriter');
      }, 3000);

      var debounceTimer = null;
      function schedule() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          processPrices(container);
        }, 80);
      }

      if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(schedule);
        observer.observe(container, { childList: true, subtree: true, characterData: true });
      }

      /* Initial sync — covers the case where UFE has already painted
         before this script ran. The debounce inside `schedule` also
         coalesces the inevitable burst of observer fires UFE produces
         as it builds its widget. */
      schedule();
    }

    function processPrices(root) {
      /* Target the leaf <span> inside each `.upsellPrice` block. UFE
         emits `id="uprice"` on each — duplicate IDs across cards which
         is invalid HTML, but the parent class is reliable and unique
         per card. Confirmed live DOM (Helixo UFE app):

           <div class="upsellPrice ufe-price">
             <span id="uprice" style="color: ...">£19.00</span>
           </div>
      */
      var priceEls = root.querySelectorAll('.upsellPrice > span');
      Array.prototype.forEach.call(priceEls, function (el) {
        /* Already rewritten — leave it alone. */
        if (el.querySelector('.ufe-vat-inc')) return;
        /* No UK VAT for this country (snippets/market-vat): UFE's own price
           is already the right one, so just reveal it. */
        if (window.theme && window.theme.market && window.theme.market.vatRate === 1) { el.classList.add('is-vat-ready'); return; }

        var raw = (el.textContent || '').trim();
        if (!raw) return;

        /* Match the first numeric chunk (with commas + optional decimals).
           Skips currency prefixes / suffixes. Handles "£19.00",
           "GBP 19.00", "£1,234.56". Bails on text without numbers
           (e.g. "Sold out"). */
        var match = raw.match(/[\d,]+(?:\.\d+)?/);
        if (!match) return;
        var exPounds = parseFloat(match[0].replace(/,/g, ''));
        if (isNaN(exPounds) || exPounds <= 0) return;

        var vatRate = (window.theme && window.theme.market && window.theme.market.vatRate) || 1.2;
        var incPounds = Math.round(exPounds * vatRate * 100) / 100;
        var incStr = (window.theme && window.theme.formatMoney) ? window.theme.formatMoney(Math.round(incPounds * 100)) : formatPounds(incPounds);

        el.innerHTML =
          '<span class="ufe-vat-inc">' + escapeHtml(incStr) + '</span>' +
          '<span class="ufe-vat-ex">' + escapeHtml(raw) + ' (Exc VAT)</span>';
        /* Mark as processed — the CSS rule reveals the element via
           `visibility: visible` and runs the fade-in animation once
           this class is present. */
        el.classList.add('is-vat-ready');
      });
    }

    function formatPounds(num) {
      var fixed = num.toFixed(2);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '£' + whole + '.' + parts[1];
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
